// extracted by mini-css-extract-plugin
module.exports = {"uploadButton":"mobileUpload_uploadButton__3PZ3i"};